import React from "react";
import classNames from "classnames";
import { DoorIconProps } from "../doorOptions/DeKaap";

export const Cool: React.FC<DoorIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width={29}
      height={60}
      viewBox="0 0 29 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("gg-transition gg-ease-in-out gg-duration-150", {
        "gg-fill-[#292747]": isActive,
        "gg-fill-[#9493A3]": !isActive,
      })}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.91 2h23.272v6.318H2.909zm-2 7.318V0h27.272v60H.909V9.318m2 32V58h23.272V41.318zm23.272-1H2.909v-6h23.273zm0-31v24H2.909v-24z"
      />
    </svg>
  );
};
